import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import styles from "../styles/list.module.css";
import commonStyles from "../../../lib/common/common.module.css";
import { APP_ROUTES, LOCAL_CONSTANTS } from "../../../lib/constants";
import { LoyalityPointTypes } from "../../../interfaces";
import { getUserLoyalityPoints } from "../api";
import { Layout, Pagination } from "../../../ui";


const LoyalityPoints = () => {
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    skip: 0,
    limit: LOCAL_CONSTANTS.limitCount,
  });
  const [search, setSearch] = useState<string>("");
  const [order, setSortOrder] = useState<number>(0);
  const [sortBy, setSortColumn] = useState<string>("");


  const [users, setLoyalityPoints] = useState<{ list: LoyalityPointTypes.UserLoyalityPointOrder[]; count: number }>({
    list: [],
    count: 0,
  });

  const [loading, setLoading] = useState<boolean>(true);

  const listLoyalityPoints = (
    pageIndex = pagination.skip,
  ) => {
    const query = {
      page: (1 + pageIndex),
      limit: pagination.limit,
      search,
      order,
      sortBy,
    };

    getUserLoyalityPoints(query).then(({ data }) => {
      setLoyalityPoints({ list: data.orders, count: data.count });
      setLoading(false);
    });
  };

  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      listLoyalityPoints();
    }, 500);
    return () => {
      clearTimeout(debounceSearch);
    };
  }, [search]);

  useEffect(() => {
    setLoading(true);
    listLoyalityPoints();
  }, [pagination.skip]);


  const handleSort = (column: string) => {
    setSortColumn(column);
    setSortOrder(
      order === LOCAL_CONSTANTS.descKey
        ? LOCAL_CONSTANTS.ascKey
        : LOCAL_CONSTANTS.descKey
    );
    const query = {
      ...pagination,
      search,
      order:
        order === LOCAL_CONSTANTS.descKey
          ? LOCAL_CONSTANTS.ascKey
          : LOCAL_CONSTANTS.descKey,
      sortBy: column,
    };
    getUserLoyalityPoints(query).then(({ data }) => {
      setLoyalityPoints({ list: data.orders, count: data.count });
      setLoading(false);
    });
  };

  const renderSortIcon = (column: string) => {
    if (sortBy === column) {
      return order === LOCAL_CONSTANTS.descKey ? " ▼" : " ▲";
    }
    return null;
  };

  return (
    <Layout title="Loyality Points">
      <div className={commonStyles.tableData}>
        <div className={commonStyles.topFilter}>
          <input
            type="search"
            placeholder="Search by name"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
          <button onClick={() => navigate(APP_ROUTES.LOYALITY_POINTS_SETTINGS)} className={styles.loyalityPointBtn} >Edit Loyality Point</button>
        </div>
        <div className={styles.scrollTable}>
          <table>
            <thead>
              <tr>
                {LOCAL_CONSTANTS.loyalityTableHeaders?.map((header: any) => (
                  <th
                    className={`${header?.value
                      ? "cursor-pointer"
                      : ""
                      }`}
                    onClick={() => {
                      if (header?.value) {
                        handleSort(header?.value);
                      }
                    }}
                    key={header?.value}
                  >
                    {header?.label}
                    {sortBy === header?.value &&
                      header?.value &&
                      renderSortIcon(header?.value)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={7} align="center" className={styles.loadingText}>
                    {LOCAL_CONSTANTS.loading}
                  </td>
                </tr>
              )}
              {!loading && users.list.length === 0 && (
                <tr>
                  <td colSpan={7} align="center">
                    No Order Found
                  </td>
                </tr>
              )}
              {!loading &&
                users.list.map((item) => (
                  <tr key={item._id}>
                    <td>{item.fullName}</td>
                    <td>{item.priceBeforeLoyality.toFixed(3)}</td>
                    <td>{item.priceAfterLoyality.toFixed(3)}</td>
                    <td>{item.quantity}</td>
                    <td>{item.loyalityPoint.toFixed(3)}</td>
                    <td>{moment(item.createdAt).format("MM-DD-YYYY")}</td>

                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <Pagination
          paginationState={pagination}
          setPaginationState={setPagination}
          count={users.count}
        />
      </div>
    </Layout>
  );
};

export default LoyalityPoints;
